export default __webpack_public_path__ + "static/media/scottHeadshot.c46cadd6.svg";